// Unit helpers: values are always stored in metric (cm / kg).
export const KG_PER_LB = 0.45359237;
export const CM_PER_IN = 2.54;

export const kgToLb = (kg) => (kg == null ? '' : Math.round(kg / KG_PER_LB * 10) / 10);
export const lbToKg = (lb) => (lb === '' || lb == null ? null : Number(lb) * KG_PER_LB);

export const cmToIn = (cm) => (cm == null ? '' : Math.round(cm / CM_PER_IN * 10) / 10);
export const inToCm = (inches) => (inches === '' || inches == null ? null : Number(inches) * CM_PER_IN);

export const cmToFtIn = (cm) => {
  if (cm == null) return { ft: '', in: '' };
  const total = cm / CM_PER_IN;
  const ft = Math.floor(total / 12);
  return { ft, in: Math.round((total - ft * 12) * 10) / 10 };
};

export const ftInToCm = (ft, inches) => {
  const f = Number(ft) || 0;
  const i = Number(inches) || 0;
  if (!f && !i) return null;
  return (f * 12 + i) * CM_PER_IN;
};

export const formatWeight = (kg, system) =>
  kg == null ? '—' : system === 'imperial' ? `${kgToLb(kg)} lb` : `${Math.round(kg * 10) / 10} kg`;

export const formatLength = (cm, system) => {
  if (cm == null) return '—';
  if (system !== 'imperial') return `${Math.round(cm * 10) / 10} cm`;
  return `${cmToIn(cm)} in`;
};

export const formatHeight = (cm, system) => {
  if (cm == null) return '—';
  if (system !== 'imperial') return `${Math.round(cm)} cm`;
  const { ft, in: inches } = cmToFtIn(cm);
  return `${ft}′ ${inches}″`;
};
